// tslint:disable:max-line-length

import React from 'react';

export const EditorBackgroundColor = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,12.7c0,0.7,0.4,1.2,1.3,1.2c0.9,0,1.4-0.5,1.4-1.2s-1.3-2.6-1.3-2.6S0,12,0,12.7z" />
      <path d="M7.4,0.2L0.4,7.2l8.6,8.6L16,8.8L7.4,0.2z M2.6,7.2l4.8-4.8l3,3L2.6,7.2z" />
    </svg>
  );
};
